





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import CollectionContainer from '@/components/collections/CollectionContainer.vue';
import { Collection } from '@/resource/collection/collection.model';
import ModalAddCollection from '@/components/modals/ModalAddCollection.vue';
import CollectionLoading from '@/components/collections/CollectionLoading.vue';
import CollectionStore, {
  CollectionStoreInterface,
} from '@/resource/collection/collection.store';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: {
    BeatLoader,
    CollectionContainer,
    ModalAddCollection,
    CollectionLoading,
  },
})
export default class CollectionList extends Vue {
  collectionStore: CollectionStoreInterface = CollectionStore;

  @Prop({ default: 0 })
  questionId!: number;

  @Prop({ default: 0 })
  answerPosition!: number;

  @Prop({ default: true })
  isObjective!: boolean;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  isLoading = true;
  isAddQuestionLoading = false;

  showAddCollection = false;
  showAddQuestionOption = false;

  collections: Collection[] = [];

  async created() {
    if (this.questionId) {
      this.showAddQuestionOption = true;
    }
    await this.fetchCollections();
  }

  async fetchCollections() {
    this.isLoading = true;

    await this.collectionStore.fetchCollections();

    if (!this.collectionStore.error) {
      this.collections = this.collectionStore.collections;
    }

    this.isLoading = false;
  }

  async createCollection(name: string) {
    await this.collectionStore.createCollection({
      name,
      subjectUuid: 'science',
    });
  }

  addCollectionClicked() {
    if (this.isAddQuestionLoading) return;

    this.showAddCollection = true;
  }

  async closeAddCollection(refetchCollections = false) {
    if (this.isAddQuestionLoading) return;
    this.showAddCollection = false;
    if (refetchCollections) {
      await this.fetchCollections();
    }
  }

  async addQuestionToCollection(collectionUuid: string) {
    if (this.isLoading) return;
    if (this.isAddQuestionLoading) return;

    this.isAddQuestionLoading = true;
    await this.collectionStore.addQuestion({
      questionId: this.questionId,
      collectionUuid,
      answerPosition: this.answerPosition + 1,
      isSubjective: !this.isObjective,
      languages: this.languages,
    });

    this.$toasted.global.mainToast({
      message: 'Question successfully added',
    });

    this.isAddQuestionLoading = false;
  }
}
